import { useSelector, useDispatch } from 'react-redux';
import MuiSnackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import { hideSnackbar } from '../../store/SnackbarSlice';

const Snackbar = () => {
  const dispatch = useDispatch();
  const { open, message, severity } = useSelector((state) => state.snackbar);

  const handleClose = (_, reason) => {
    if (reason === 'clickaway') return;
    dispatch(hideSnackbar());
  };

  return (
    <MuiSnackbar
      open={open}
      autoHideDuration={4000}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
    >
      <MuiAlert
        elevation={6}
        variant='filled'
        onClose={handleClose}
        severity={severity}
        sx={{
          width: 'auto',
          minWidth: '26vw',
          maxWidth: '40vw',
          whiteSpace: 'pre-line',
          wordBreak: 'break-word',
          display: 'inline-flex',
          alignItems: 'center',
        }}
      >
        {message}
      </MuiAlert>
    </MuiSnackbar>
  );
};

export default Snackbar;
